import React from 'react';
import { useParams } from 'react-router-dom';
import person4 from '../../../../assets/images/user-update2.png';
import { permissionObj } from '../../../../Helpers/permission';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import Step1Details from './EnrollmentSteps/Step1Details';
import Step2OtherDetails from './EnrollmentSteps/Step2OtherDetails';
import Step3EmployeeContract from './EnrollmentSteps/Step3EmployeeContract';
import Step4AccessRights from './EnrollmentSteps/Step4AccessRights';
import Step6CapturerFinger from './EnrollmentSteps/Step6CaptureFinger';
import Step7Card from './EnrollmentSteps/Step7Card';
import { toast } from 'react-toastify';
import FullPageLoader from '../../../../utils/FullPageLoader';
import DocumentTable from '../../../Modals/DocumentTable';
import SendQrBtn from '../../../../components/buttons/SendQrBtn';
import UnlinkDeviceBtn from '../../../../components/buttons/UnlinkDeviceBtn';
import Step9DrivingPermits from './EnrollmentSteps/Step9DrivingPermits';
import DeleteModal from '../../../Modals/DeleteModal';
import PluginWarnModal from '../../../Modals/PluginWarnModal';
import BtnResetByAttemps from '../../../../components/buttons/BtnResetByAttemps';
import BtnResetByImpersonation from '../../../../components/buttons/BtnResetByImpersonation';
import GenerateVCard from './Modal/GenerateVCard';
import FingerPrintSpinner from './Modal/FingerPrintSpinner';
import EmployeeApp from './Functionality/EmployeeApp';
import routes from '../../../../Routes/routes';
import HeadTittle from '../../../../components/HeadTittle';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import {EditIcon} from '../../../../components/buttons/IconButtons';
import DivContainerBody from '../../../../components/DivContainerBody';
import ImagePreview from '../../../../components/ImagePreview';
import StepperTabs from '../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../components/StepperTabs/StepTab';
import CopySecretModal from "./Modal/CopySecretModal";
import CustomPhotoPicker from '../../../../components/PhotoPicker/CustomPhotoPicker';
import {ACTION_MODEL} from '../../../../Helpers/ActionModel';
import {FILE_TYPE} from '../../../../Helpers/fileType';
import {SUGGESTION_MODE_OPTION} from '../../../../components/PhotoPicker/SubComponent/Models/Models';
import {STATUS_MODEL} from '../../../../enums/statusEnum';

const UpdateEmployee = () => {
    const { id } = useParams();

    const {
        navigate,
        contractorId,
        supplierId,
        permission,
        DEV,
        t,
        employeeWorkStations,
        headersList,
        employeeRoles,
        contractStatusList,
        getUserRestriction,
        employeeDepartments,
        disabled,
        steps,
        activeStep, setActiveStep,
        userData, setUserData,
        extraData, setExtraData,
        employeeData, setEmployeeData,
        isValidEmail,
        isValidPassword,
        isValidDocumentId,
        isValidPin,
        isValidPhoneNumber,
        isValidDob, setIsValidDob,
        isValidStartDate, setIsValidStartDate,
        isValidEndDate, setIsValidEndDate,
        emptyFields, setEmptyFields,
        selectVehicleForDelete,
        isAllChecked,
        cardsList, setCardsList,
        documentsList,
        ProfileImage,
        url2,
        showUnlinkBtn,
        extraDataEnabled,
        loadingProgress, setLoadingProgress,
        fingerprintsList,
        setCardData,
        setCardDataInfo,
        updated, setUpdated,
        workShiftsList, setWorkShiftsList,
        customizedList, setCustomizedList,
        vehicleData,
        updatedFinger, setUpdatedFinger,
        selectedReader, setSelectedReader,
        availableReaders, setAvailableReaders,
        fingerprintName, setFingerprintName,
        capturedFingerprint, setCapturedFingerprint,
        capturing, setCapturing,
        fingerprintSrc, setFingerprintSrc,
        deletePermitShow, setDeletePermitShow,
        vCardShow, setVCardShow,
        showPluginWarn, setShowPluginWarn,
        secretModal, setSecretModal,
        secretKey, setSecretKey,
        setModified,
        photoPickerFile,
        setPhotoPickerFile,
        handleStepChange,
        handleFormChangeUserData,
        handleUpdateEmployee,
        handleUploadFinger,
        deleteSelectedPermits,
        handleCloseModal,
        handleDeleteAll,
        handleCheckboxChangeVehicle,
        handleFormChangeExtraData,
        handleFormChangeEmployeeData,
        handleDeleteImage,
        isPilgrimsValidation,
        isSelfieValid,
        emptySelfie,
        setEmptySelfie,
        isValidCecoCode
    } = EmployeeApp();

    if(contractorId === null && supplierId === null && !DEV && !permission?.includes(permissionObj?.WEB_EMPLOYEE_UPDATE)) navigate(routes.forbidden);
    return (
        <>
            {capturing && <FingerPrintSpinner onClose={handleCloseModal} capturing={capturing} />}
            {loadingProgress && <FullPageLoader />}

            <HeadTittle link={routes.employee.list} name={'update'}>

                {(DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_UPDATE)) && (
                    <ButtonAction
                        id='btn_up_update'
                        name={'update'}
                        className={'btn-icon-edit'}
                        Icon={EditIcon}
                        onClick={() => {
                            if (
                                employeeData.roleId !== '' &&
                                employeeData.employeeId !== '' &&
                                employeeData.startDate !== null &&
                                isValidStartDate && isValidEndDate &&
                                userData.isValid() &&
                                employeeData.isValid(isPilgrimsValidation) &&
                                isValidEmail &&
                                isValidPassword &&
                                isValidPhoneNumber &&
                                isValidDob &&
                                isValidDocumentId &&
                                isValidPin &&
                                (!isPilgrimsValidation || isSelfieValid) &&
                                isValidCecoCode
                            ) {
                                handleUpdateEmployee();
                                setEmptyFields(false);
                                setEmptySelfie(false);
                            } else {
                                if (isPilgrimsValidation && !isSelfieValid) {
                                  setEmptySelfie(true);
                                }
                                setEmptyFields(true);
                                toast.warn(t('please_fill_all_fields'));
                            }
                        }}
                    />
                )}

                {(DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_UPDATE)) && getUserRestriction.extraDataEmployee && (
                    <ButtonAction
                        id='btn_ae_import_data'
                        name='generate_vcode'
                        className='btn-icon-export'
                        Icon={ MailOutlineIcon }
                        disabled={false}
                        splitName={false}
                        onClick={()=>{
                            setVCardShow(true);
                        }}
                    />
                )}

                { userData.statusId === STATUS_MODEL.ACCOUNT_LOCKED && <BtnResetByAttemps id={userData.id} />}
                { userData.statusId === STATUS_MODEL.IDENTITY_THEFT && <BtnResetByImpersonation id={userData.id} />}
                <SendQrBtn userId={userData.id} />
                { showUnlinkBtn && <UnlinkDeviceBtn userId={userData.id} updated={() => setUpdated(true)} />}

            </HeadTittle>

            <DivContainerBody>
                <ImagePreview
                    className='mb-4 justify-content-center'
                    preview={ProfileImage !== null ? url2 : person4}
                />

            {extraDataEnabled ? (
                <>
                    <StepperTabs id={id} disabled={disabled} steps={steps} activeStep={activeStep}
                                 isStepOptional={() => { }} setActiveStep={setActiveStep}
                                 handleStepChange={handleStepChange} >

                        <StepTab index={0} activeStep={activeStep} normalHeight={true}>
                            <Step1Details
                                userData={userData}
                                onChange={handleFormChangeUserData}
                                emptyFields={emptyFields}
                                isValidPhoneNumber={isValidPhoneNumber}
                                isValidDocumentId={isValidDocumentId}
                                isValidDob={isValidDob}
                                setIsValidDob={setIsValidDob}
                                isValidPin={isValidPin}
                                isValidEmail={isValidEmail}
                            />
                        </StepTab>
                        <StepTab index={1} activeStep={activeStep} normalHeight={true}>
                            <Step2OtherDetails
                                showBtnClean={userData?.id == null || userData?.id == ''}
                                extraData={extraData}
                                onChange={handleFormChangeExtraData}
                                setExtraData={setExtraData}
                                headersList={headersList}
                            />
                        </StepTab>
                        <StepTab index={2} activeStep={activeStep} normalHeight={true}>
                            <Step3EmployeeContract
                                employeeData={employeeData}
                                employeeRoles={employeeRoles}
                                employeeWorkStations={employeeWorkStations}
                                contractStatusList={contractStatusList}
                                employeeDepartments={employeeDepartments}
                                emptyFields={emptyFields}
                                isValidStartDate={isValidStartDate}
                                setIsValidStartDate={setIsValidStartDate}
                                isValidEndDate={isValidEndDate}
                                setIsValidEndDate={setIsValidEndDate}
                                onChange={handleFormChangeEmployeeData}
                                setEmployeeData={setEmployeeData}
                                isPilgrimsValidation={isPilgrimsValidation}
                                isValidCecoCode={isValidCecoCode}
                            />
                        </StepTab>
                        <StepTab index={3} activeStep={activeStep} normalHeight={true}>
                            {(DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_UPDATE)) &&
                                <CustomPhotoPicker
                                    id='fp_ce_update_photo_profile'
                                    photoPicker={photoPickerFile}
                                    setPhotoPicker={setPhotoPickerFile}
                                    actionModel={ACTION_MODEL.UPDATE}
                                    accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                                    showBtnCamera={true}
                                    emptyFields={emptySelfie}
                                    required={isPilgrimsValidation}
                                    validateFace={true}
                                    classWith={'w-400px'}
                                    showPreview={true}
                                    disabled={disabled}
                                    titleModalEdit='update_photography'
                                    typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE} // It is required if showBtnCamera is true
                                    handleDelete={photoPickerFile?.previewImage ? handleDeleteImage : undefined}
                                />
                            }
                        </StepTab>
                        <StepTab index={4} activeStep={activeStep} normalHeight={true}>
                            {activeStep == 4 &&
                                <Step7Card
                                    cardsList={cardsList}
                                    setCardsList={setCardsList}
                                    userData={userData}
                                    setCardData={setCardData}
                                    setCardDataInfo={setCardDataInfo}
                                    componentAction='update'
                                />
                            }
                        </StepTab>
                        <StepTab index={5} activeStep={activeStep} normalHeight={true}>
                            {activeStep == 5 &&
                                <DocumentTable
                                    dataTable={documentsList}
                                    approve={true}
                                    optionDownload='employee_document'
                                    employeeName={userData.name || '' + ' ' + userData.lastName || ''}
                                    updated={updated}
                                    setUpdated={setUpdated}
                                />
                            }
                        </StepTab>
                        <StepTab index={6} activeStep={activeStep} normalHeight={true}>
                            {activeStep == 6 &&
                                <Step9DrivingPermits
                                    vehicleData={vehicleData}
                                    selectVehicleForDelete={selectVehicleForDelete}
                                    handleCheckboxChange={handleCheckboxChangeVehicle}
                                    isAllChecked={isAllChecked}
                                    handleCheckedAll={handleDeleteAll}
                                    handleDelete={()=>{
                                        setDeletePermitShow(true)
                                    }}
                                />
                            }
                        </StepTab>
                        <StepTab index={7} activeStep={activeStep} normalHeight={true}>
                            <Step4AccessRights
                                userData={userData}
                                employeeData={employeeData}
                                workShiftsList={workShiftsList}
                                setWorkShiftsList={setWorkShiftsList}
                                customizedList={customizedList}
                                setCustomizedList={setCustomizedList}
                                onChange={handleFormChangeEmployeeData}
                                setEmployeeData={setEmployeeData}
                                isEditable={true}
                            />
                        </StepTab>
                        <StepTab index={8} activeStep={activeStep} normalHeight={true}>
                            {activeStep == 8 &&
                                <Step6CapturerFinger
                                    employeeData={employeeData}
                                    userData={userData}
                                    onChange={handleFormChangeEmployeeData}
                                    selectedReader={selectedReader}
                                    setSelectedReader={setSelectedReader}
                                    availableReaders={availableReaders}
                                    setAvailableReaders={setAvailableReaders}
                                    fingerprintSrc={fingerprintSrc}
                                    fingerprintsList={fingerprintsList}
                                    handleUploadFinger={handleUploadFinger}
                                    fingerprintName={fingerprintName}
                                    setFingerprintName={setFingerprintName}
                                    setFingerprintSrc={setFingerprintSrc}
                                    updated={updated}
                                    setUpdated={setUpdated}
                                    updatedFinger={updatedFinger}
                                    setUpdatedFinger={setUpdatedFinger}
                                    loadingProgress={loadingProgress}
                                    setLoadingProgress={setLoadingProgress}
                                    capturing={capturing}
                                    setCapturing={setCapturing}
                                    emptyFields={emptyFields}
                                    setEmptyFields={setEmptyFields}
                                    setEmployeeData={setEmployeeData}
                                    capturedFingerprint={capturedFingerprint}
                                    setCapturedFingerprint={setCapturedFingerprint}
                                    setModified={setModified}
                                />
                            }
                        </StepTab>

                    </StepperTabs>
                </>
            ) : (
                <>
                    <StepperTabs id={id} disabled={disabled} steps={steps} activeStep={activeStep}
                                 isStepOptional={() => { }} setActiveStep={setActiveStep}
                                 handleStepChange={handleStepChange} >

                        <StepTab index={0} activeStep={activeStep} normalHeight={true}>
                            <Step1Details
                                userData={userData}
                                onChange={handleFormChangeUserData}
                                emptyFields={emptyFields}
                                isValidDocumentId={isValidDocumentId}
                                isValidPhoneNumber={isValidPhoneNumber}
                                isValidDob={isValidDob}
                                setIsValidDob={setIsValidDob}
                                isValidPin={isValidPin}
                                isValidEmail={isValidEmail}
                            />
                        </StepTab>
                        <StepTab index={1} activeStep={activeStep} normalHeight={true}>
                            <Step3EmployeeContract
                                employeeData={employeeData}
                                employeeRoles={employeeRoles}
                                employeeWorkStations={employeeWorkStations}
                                contractStatusList={contractStatusList}
                                employeeDepartments={employeeDepartments}
                                emptyFields={emptyFields}
                                isValidStartDate={isValidStartDate}
                                setIsValidStartDate={setIsValidStartDate}
                                isValidEndDate={isValidEndDate}
                                setIsValidEndDate={setIsValidEndDate}
                                onChange={handleFormChangeEmployeeData}
                                setEmployeeData={setEmployeeData}
                                isPilgrimsValidation={isPilgrimsValidation}
                                isValidCecoCode={isValidCecoCode}
                            />
                        </StepTab>
                        <StepTab index={2} activeStep={activeStep} normalHeight={true}>
                            {(DEV || permission?.includes(permissionObj?.WEB_EMPLOYEE_UPDATE)) &&
                                <CustomPhotoPicker
                                    id='fp_ce_update_photo_profile'
                                    photoPicker={photoPickerFile}
                                    setPhotoPicker={setPhotoPickerFile}
                                    actionModel={ACTION_MODEL.UPDATE}
                                    accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                                    showBtnCamera={true}
                                    validateFace={true}
                                    classWith={'w-400px'}
                                    showPreview={true}
                                    emptyFields={emptySelfie}
                                    required={isPilgrimsValidation}
                                    disabled={disabled}
                                    titleModalEdit='update_photography'
                                    typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE} // It is required if showBtnCamera is true
                                    handleDelete={photoPickerFile?.previewImage ? handleDeleteImage : undefined}
                                />
                            }
                        </StepTab>
                        <StepTab index={3} activeStep={activeStep} normalHeight={true}>
                            {activeStep == 3 &&
                                <Step7Card
                                    cardsList={cardsList}
                                    setCardsList={setCardsList}
                                    userData={userData}
                                    setCardData={setCardData}
                                    setCardDataInfo={setCardDataInfo}
                                    componentAction='update'
                                />
                            }
                        </StepTab>
                        <StepTab index={4} activeStep={activeStep} normalHeight={true}>
                            {activeStep == 4 &&
                                <DocumentTable
                                    dataTable={documentsList}
                                    approve={true}
                                    optionDownload='employee_document'
                                    employeeName={userData.name || '' + ' ' + userData.lastName || ''}
                                    updated={updated}
                                    setUpdated={setUpdated}
                                />
                            }
                        </StepTab>
                        <StepTab index={5} activeStep={activeStep} normalHeight={true}>
                            {activeStep == 5 &&
                                <Step9DrivingPermits
                                    vehicleData={vehicleData}
                                    selectVehicleForDelete={selectVehicleForDelete}
                                    handleCheckboxChange={handleCheckboxChangeVehicle}
                                    isAllChecked={isAllChecked}
                                    handleCheckedAll={handleDeleteAll}
                                    handleDelete={()=>{
                                        setDeletePermitShow(true)
                                    }}
                                />
                            }
                        </StepTab>
                        <StepTab index={6} activeStep={activeStep} normalHeight={true}>
                            <Step4AccessRights
                                userData={userData}
                                employeeData={employeeData}
                                workShiftsList={workShiftsList}
                                setWorkShiftsList={setWorkShiftsList}
                                customizedList={customizedList}
                                setCustomizedList={setCustomizedList}
                                onChange={handleFormChangeEmployeeData}
                                setEmployeeData={setEmployeeData}
                                isEditable={true}
                            />
                        </StepTab>
                        <StepTab index={7} activeStep={activeStep} normalHeight={true}>
                            {activeStep == 7 &&
                                <Step6CapturerFinger
                                    employeeData={employeeData}
                                    userData={userData}
                                    onChange={handleFormChangeEmployeeData}
                                    selectedReader={selectedReader}
                                    setSelectedReader={setSelectedReader}
                                    availableReaders={availableReaders}
                                    setAvailableReaders={setAvailableReaders}
                                    fingerprintSrc={fingerprintSrc}
                                    fingerprintsList={fingerprintsList}
                                    handleUploadFinger={handleUploadFinger}
                                    fingerprintName={fingerprintName}
                                    setFingerprintName={setFingerprintName}
                                    setFingerprintSrc={setFingerprintSrc}
                                    updated={updated}
                                    setUpdated={setUpdated}
                                    updatedFinger={updatedFinger}
                                    setUpdatedFinger={setUpdatedFinger}
                                    loadingProgress={loadingProgress}
                                    setLoadingProgress={setLoadingProgress}
                                    capturing={capturing}
                                    setCapturing={setCapturing}
                                    emptyFields={emptyFields}
                                    setEmptyFields={setEmptyFields}
                                    setEmployeeData={setEmployeeData}
                                    capturedFingerprint={capturedFingerprint}
                                    setCapturedFingerprint={setCapturedFingerprint}
                                    setModified={setModified}
                                />
                            }
                        </StepTab>

                    </StepperTabs>
                </>
            )}
            </DivContainerBody>

            <DeleteModal
                show={deletePermitShow}
                onHide={() => setDeletePermitShow(false)}
                onClickFn={() => deleteSelectedPermits()}
                data={selectVehicleForDelete}
                title_modal={t('delete_permits')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('permits')}
            />
            <GenerateVCard show={vCardShow} onHide={() => setVCardShow(false)} />
            <PluginWarnModal show={showPluginWarn} onHide={() => setShowPluginWarn(false)} />
            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUserData}
                onHide={() => {}}
                closeText={"close"}
            />
        </>
    );
};

export default UpdateEmployee;
